export default "__VITE_ASSET__vsfNug2y__"